import React from 'react';
import ListItem from 'components/ListItem';

import { SprayApplicationRate } from 'services/sprayEvents/types';

export interface OwnProps {
    applicationRate: SprayApplicationRate;
}

type Props = OwnProps;

export default class SummaryApplicationWaterRateListItem extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { applicationRate } = this.props;

        return (
            <ListItem
                description="Water rate"
                value={`${applicationRate} L/ha`}
            />
        );
    }
}
